(function () {
  const moneyFormat = window.FourUTheme?.moneyFormat || '£{{amount}}';
  const THEME_KEY = '4u-color-scheme';
  let scrollLockY = 0;
  let cartTrigger = null;
  let navTrigger = null;
  let focusTrapCleanup = null;

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  window.FourUTheme = window.FourUTheme || {};
  window.FourUTheme.formatMoney = formatMoney;

  function parseMoneyValue(rawValue) {
    const parsed = Number(rawValue);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getElements() {
    return {
      cartDrawer: document.getElementById('cartDrawer'),
      cartOverlay: document.getElementById('cartOverlay'),
      openCartHeader: document.getElementById('openCartHeader'),
      closeCartBtn: document.getElementById('closeCart'),
      mobileNav: document.getElementById('mobileNav'),
      openNavBtn: document.getElementById('openNavBtn'),
      closeNavBtn: document.getElementById('closeNavBtn'),
      heroSection: document.getElementById('hero'),
      stickyCart: document.getElementById('stickyCart'),
      productGallery: document.getElementById('productGallery'),
      sliderPrev: document.getElementById('sliderPrev'),
      sliderNext: document.getElementById('sliderNext'),
      cartItemsEl: document.getElementById('cartItems'),
      cartSubtotalEl: document.getElementById('cartSubtotal'),
      cartStatusEl: document.getElementById('cartStatus'),
      shippingTextEl: document.getElementById('shippingText'),
      progressFillEl: document.getElementById('progressFill'),
      checkoutBtn: document.getElementById('checkoutBtn'),
      themeToggle: document.getElementById('themeToggle'),
      toastEl: document.getElementById('fouruToast')
    };
  }

  // The cart drawer is present on every page, but a standalone /cart page (or any
  // future cart surface) can render its own copy of these elements tagged with the
  // matching data-cart-* attributes. Everything cart-related updates ALL of them in
  // lockstep, so the drawer and the full page never fall out of sync with each other.
  function getCartSurfaces() {
    return {
      itemsEls: document.querySelectorAll('[data-cart-items]'),
      subtotalEls: document.querySelectorAll('[data-cart-subtotal]'),
      statusEls: document.querySelectorAll('[data-cart-status]'),
      shippingTextEls: document.querySelectorAll('[data-cart-shipping-text]'),
      progressFillEls: document.querySelectorAll('[data-cart-progress-fill]'),
      checkoutBtns: document.querySelectorAll('[data-checkout-btn]'),
      openCartLabelEls: document.querySelectorAll('[data-cart-open-label]')
    };
  }

  function getTheme() {
    return document.documentElement.getAttribute('data-theme') || 'dark';
  }

  function setTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(THEME_KEY, theme);

    const meta = document.getElementById('themeColorMeta');
    if (meta) meta.setAttribute('content', theme === 'light' ? '#ffffff' : '#000000');

    const { themeToggle } = getElements();
    if (themeToggle) {
      const isLight = theme === 'light';
      themeToggle.setAttribute('aria-pressed', isLight ? 'true' : 'false');
      themeToggle.setAttribute('aria-label', isLight ? 'Switch to dark mode' : 'Switch to light mode');
    }
  }

  function bindThemeToggle() {
    const { themeToggle } = getElements();
    if (!themeToggle) return;

    setTheme(getTheme());

    themeToggle.addEventListener('click', () => {
      setTheme(getTheme() === 'light' ? 'dark' : 'light');
    });
  }

  function showToast(message, type = 'info') {
    const { toastEl } = getElements();
    if (!toastEl) return;

    toastEl.textContent = message;
    toastEl.className = `toast toast--${type} toast--visible`;

    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(() => {
      toastEl.classList.remove('toast--visible');
    }, 4500);
  }

  function setBodyLock(lock) {
    if (lock) {
      scrollLockY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollLockY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      return;
    }

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollLockY);
  }

  function releaseFocusTrap() {
    if (focusTrapCleanup) {
      focusTrapCleanup();
      focusTrapCleanup = null;
    }
  }

  function trapFocus(container, returnFocusEl) {
    releaseFocusTrap();

    const focusable = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function handleKeydown(e) {
      if (e.key !== 'Tab') return;

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', handleKeydown);
    focusTrapCleanup = () => {
      container.removeEventListener('keydown', handleKeydown);
      if (returnFocusEl) returnFocusEl.focus();
    };
  }

  function toggleCart(show) {
    const { cartDrawer, cartOverlay, closeCartBtn, mobileNav } = getElements();
    if (!cartDrawer || !cartOverlay) return;

    if (show) {
      toggleNav(false, false);
      cartTrigger = document.activeElement;
    }

    cartDrawer.classList.toggle('active', show);
    cartOverlay.classList.toggle('active', show);
    cartDrawer.setAttribute('aria-hidden', show ? 'false' : 'true');
    cartOverlay.setAttribute('aria-hidden', show ? 'false' : 'true');

    const navOpen = mobileNav && mobileNav.classList.contains('active');
    setBodyLock(show || navOpen);

    if (show) {
      trapFocus(cartDrawer, cartTrigger);
      if (closeCartBtn) closeCartBtn.focus();
    } else {
      releaseFocusTrap();
    }
  }

  function toggleNav(show, restoreFocus = true) {
    const { mobileNav, cartOverlay } = getElements();
    if (!mobileNav || !cartOverlay) return;

    if (show) {
      toggleCart(false);
      navTrigger = document.activeElement;
    }

    mobileNav.classList.toggle('active', show);
    cartOverlay.classList.toggle('active', show);
    mobileNav.setAttribute('aria-hidden', show ? 'false' : 'true');
    cartOverlay.setAttribute('aria-hidden', show ? 'false' : 'true');

    const cartOpen = document.getElementById('cartDrawer')?.classList.contains('active');
    setBodyLock(show || cartOpen);

    if (show) {
      trapFocus(mobileNav, navTrigger);
      const closeNavBtn = document.getElementById('closeNavBtn');
      if (closeNavBtn) closeNavBtn.focus();
    } else if (restoreFocus) {
      releaseFocusTrap();
    }
  }

  function updateShippingBar(cart) {
    const { shippingTextEls, progressFillEls } = getCartSurfaces();
    const threshold = window.FourUTheme?.freeShippingThreshold || 3000;
    const subtotal = cart.total_price || 0;
    const remaining = Math.max(threshold - subtotal, 0);

    const shippingHtml = remaining === 0
      ? 'You\'ve unlocked <strong>FREE shipping</strong>!'
      : `You are <strong>${formatMoney(remaining)}</strong> away from FREE shipping!`;
    shippingTextEls.forEach((el) => { el.innerHTML = shippingHtml; });

    const pct = Math.min((subtotal / threshold) * 100, 100);
    progressFillEls.forEach((el) => { el.style.width = `${pct}%`; });
  }

  function setCartStatus(message) {
    const { statusEls } = getCartSurfaces();
    statusEls.forEach((el) => { el.textContent = message; });
  }

  function setCartBusy(busy) {
    document.querySelectorAll('[data-cart-items]').forEach((el) => {
      el.classList.toggle('is-updating', busy);
      el.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
    document.querySelectorAll('.cart-qty-btn, .cart-remove-btn').forEach((button) => {
      button.disabled = busy;
    });
  }

  function applyOptimisticQty(cartItem, nextQty) {
    if (!cartItem) return;
    const qtyValueEl = cartItem.querySelector('.cart-qty-value');
    if (qtyValueEl) qtyValueEl.textContent = String(Math.max(0, nextQty));

    /* Soft-hide the row immediately on remove / qty 0 */
    if (nextQty <= 0) {
      cartItem.style.opacity = '0.45';
      cartItem.style.pointerEvents = 'none';
    }
  }

  function renderCartItemsMarkup(cart) {
    if (!cart.items.length) return '<p class="cart-empty">Your cart is empty</p>';

    return cart.items.map((item) => `
      <div class="cart-item">
        <div class="cart-img-wrap">
          <img src="${item.image}" alt="${item.product_title}" width="80" height="80" loading="lazy">
        </div>
        <div class="item-details">
          <div class="cart-item-meta">
            <div class="cart-item-title-wrap">
              <h4>${item.product_title}</h4>
              <p>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
            </div>
            <div class="cart-line-price">${formatMoney(item.final_line_price)}</div>
          </div>
          <div class="cart-item-actions">
            <div class="cart-qty-control" aria-label="Quantity controls for ${item.product_title}">
              <button class="cart-qty-btn" type="button" data-cart-action="decrease" data-line-key="${item.key || item.variant_id || item.id}" aria-label="Decrease quantity of ${item.product_title}">−</button>
              <span class="cart-qty-value" aria-live="polite">${item.quantity}</span>
              <button class="cart-qty-btn" type="button" data-cart-action="increase" data-line-key="${item.key || item.variant_id || item.id}" aria-label="Increase quantity of ${item.product_title}">+</button>
            </div>
            <button class="cart-remove-btn" type="button" data-cart-action="remove" data-line-key="${item.key || item.variant_id || item.id}" aria-label="Remove ${item.product_title} from cart">Remove</button>
          </div>
        </div>
      </div>
    `).join('');
  }

  function renderCart(cart) {
    const { openCartHeader } = getElements();
    const { itemsEls, subtotalEls, checkoutBtns } = getCartSurfaces();

    if (openCartHeader) {
      openCartHeader.textContent = `Cart (${cart.item_count})`;
    }

    const itemsMarkup = renderCartItemsMarkup(cart);
    itemsEls.forEach((el) => { el.innerHTML = itemsMarkup; });
    subtotalEls.forEach((el) => { el.textContent = formatMoney(cart.total_price); });
    checkoutBtns.forEach((btn) => { btn.disabled = cart.item_count === 0; });

    updateShippingBar(cart);
  }

  async function parseJsonResponse(res, fallbackMessage) {
    // Shopify's cart AJAX endpoints (/cart.js, /cart/add.js, etc.) legitimately respond
    // with a "text/javascript" content-type even though the body is JSON, so content-type
    // can't be used to detect a blocked/password-protected storefront. Attempt to parse the
    // body directly instead; a genuine password-wall response is HTML and will fail to parse.
    let data;
    try {
      data = await res.json();
    } catch (e) {
      throw new Error('Store password or login is blocking the cart. Unlock the storefront password first.');
    }

    if (!res.ok) {
      throw new Error(data.description || data.message || fallbackMessage);
    }
    return data;
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    const cart = await parseJsonResponse(res, 'Could not load cart');
    renderCart(cart);
    return cart;
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity })
    });

    await parseJsonResponse(res, 'Could not add to cart');
    return fetchCart();
  }

  async function updateCartLine({ lineKey, line, quantity }) {
    // Prefer 1-based `line` when we know which row was clicked — avoids Shopify's
    // "no valid id or line permitted" when a stale/mismatched line-item key is sent.
    // Fall back to the line-item key (`id`) when line index isn't available.
    const payload = { quantity: Number(quantity) || 0 };
    if (line != null && line > 0) {
      payload.line = line;
    } else if (lineKey) {
      payload.id = String(lineKey);
    } else {
      throw new Error('Could not update cart.');
    }

    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });

    const cart = await parseJsonResponse(res, 'Could not update cart');
    renderCart(cart);
    return cart;
  }

  function getSliderScrollAmount() {
    const card = document.querySelector('[data-product-card]');
    if (!card) return 350;
    const styles = window.getComputedStyle(card);
    const width = parseFloat(styles.width) || 320;
    const gap = parseFloat(styles.marginRight) || 30;
    return width + gap;
  }

  function bindSlider() {
    const { productGallery, sliderPrev, sliderNext } = getElements();
    if (!productGallery || !sliderPrev || !sliderNext) return;

    sliderNext.addEventListener('click', () => {
      productGallery.scrollBy({ left: getSliderScrollAmount(), behavior: 'smooth' });
    });
    sliderPrev.addEventListener('click', () => {
      productGallery.scrollBy({ left: -getSliderScrollAmount(), behavior: 'smooth' });
    });
  }

  function bindStickyBar() {
    const { heroSection, stickyCart } = getElements();
    const scrollTarget = heroSection || document.getElementById('fourher-hero') || document.querySelector('.product-page-media');
    if (!scrollTarget || !stickyCart) return;

    let ticking = false;
    const updateStickyCart = () => {
      const heroBottom = scrollTarget.offsetTop + scrollTarget.offsetHeight;
      stickyCart.classList.toggle('visible', window.scrollY > heroBottom - 100);
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateStickyCart);
        ticking = true;
      }
    }, { passive: true });
  }

  function updateStickyProductFromCard(card) {
    if (!card) return;

    const stickyImage = document.getElementById('stickyCartImage');
    const stickyTitle = document.getElementById('stickyCartTitle');
    const stickyPrice = document.getElementById('stickyCartPrice');
    const stickyButton = document.getElementById('stickyCartButton');

    const title = card.dataset.title;
    const imageSrc = card.dataset.imageSrc;
    const variantId = card.dataset.variantId;
    const price = parseMoneyValue(card.dataset.price);

    if (stickyTitle && title) stickyTitle.textContent = title;
    if (stickyPrice) stickyPrice.textContent = formatMoney(price);

    if (stickyImage && imageSrc) {
      stickyImage.src = imageSrc;
      stickyImage.alt = title || 'Selected product';
    }

    if (stickyButton) {
      if (variantId) {
        stickyButton.dataset.variantId = variantId;
        stickyButton.classList.remove('scroll-to-products', 'open-cart-trigger');
      } else {
        delete stickyButton.dataset.variantId;
        stickyButton.classList.add('open-cart-trigger');
        stickyButton.classList.remove('scroll-to-products');
      }
    }
  }

  function getMostVisibleProductCard(cards, container) {
    if (!cards.length || !container) return cards[0];

    const containerRect = container.getBoundingClientRect();
    const containerCenter = containerRect.left + (containerRect.width / 2);
    let closestCard = cards[0];
    let closestDistance = Number.POSITIVE_INFINITY;

    cards.forEach((card) => {
      const rect = card.getBoundingClientRect();
      const cardCenter = rect.left + (rect.width / 2);
      const distance = Math.abs(cardCenter - containerCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestCard = card;
      }
    });

    return closestCard;
  }

  function bindProductCards() {
    const productCards = document.querySelectorAll('[data-product-card]');
    const { productGallery } = getElements();
    if (!productCards.length) return;

    let currentStickyCard = null;
    let galleryFocusTimer = null;
    let currentGalleryFocus = null;

    const setStickyCard = (card) => {
      if (!card || card === currentStickyCard) return;
      currentStickyCard = card;
      updateStickyProductFromCard(card);
    };

    const setGalleryFocus = (card) => {
      if (!productGallery || !card || !productGallery.contains(card)) return;
      if (card === currentGalleryFocus) return;
      window.clearTimeout(galleryFocusTimer);
      /* Short settle delay so mid-swipe cards don't flicker between images */
      galleryFocusTimer = window.setTimeout(() => {
        if (currentGalleryFocus) currentGalleryFocus.classList.remove('is-gallery-focus');
        card.classList.add('is-gallery-focus');
        currentGalleryFocus = card;
      }, 220);
    };

    // Track which card is actually visible within the horizontally-scrolling gallery
    // on an ongoing basis (root = the gallery itself), so the sticky bar stays correct
    // however the user reaches it: vertical page scroll, a horizontal swipe, a resize,
    // or layout settling after images/fonts load in. A single getBoundingClientRect
    // snapshot at bind time can't account for any of that.
    if (productGallery && 'IntersectionObserver' in window) {
      const visibility = new Map();
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => visibility.set(entry.target, entry.intersectionRatio));

        let bestCard = null;
        let bestRatio = 0;
        visibility.forEach((ratio, card) => {
          if (ratio > bestRatio) {
            bestRatio = ratio;
            bestCard = card;
          }
        });

        if (bestCard) {
          setStickyCard(bestCard);
          setGalleryFocus(bestCard);
        }
      }, { root: productGallery, threshold: [0, 0.25, 0.5, 0.75, 1] });

      productCards.forEach((card) => {
        if (productGallery.contains(card)) observer.observe(card);
      });
    } else {
      const seed = getMostVisibleProductCard([...productCards], productGallery);
      setStickyCard(seed);
      setGalleryFocus(seed);
    }

    productCards.forEach((card) => {
      ['mouseenter', 'focusin', 'touchstart'].forEach((eventName) => {
        card.addEventListener(eventName, () => setStickyCard(card), { passive: eventName === 'touchstart' });
      });

      const cardButton = card.querySelector('[data-variant-id], .open-cart-trigger');
      if (cardButton) {
        cardButton.addEventListener('click', () => setStickyCard(card));
      }
    });
  }

  function bindNewsletterCopy() {
    document.querySelectorAll('.newsletter-copy-btn').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const code = btn.dataset.copyCode;
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
        } catch (err) {
          // Clipboard API needs a secure context/permission; fall back to a manual
          // select-and-copy so the button still works everywhere.
          const helper = document.createElement('textarea');
          helper.value = code;
          helper.style.position = 'fixed';
          helper.style.opacity = '0';
          document.body.appendChild(helper);
          helper.select();
          document.execCommand('copy');
          helper.remove();
        }
        const original = btn.textContent;
        btn.textContent = 'Copied!';
        btn.classList.add('is-copied');
        showToast(`Code "${code}" copied`, 'info');
        setTimeout(() => {
          btn.textContent = original;
          btn.classList.remove('is-copied');
        }, 2000);
      });
    });
  }

  function bindUI() {
    const { openCartHeader, closeCartBtn, openNavBtn, closeNavBtn, cartOverlay, mobileNav } = getElements();

    if (openCartHeader) openCartHeader.addEventListener('click', () => toggleCart(true));
    if (closeCartBtn) closeCartBtn.addEventListener('click', () => toggleCart(false));
    if (openNavBtn) openNavBtn.addEventListener('click', () => toggleNav(true));
    if (closeNavBtn) closeNavBtn.addEventListener('click', () => toggleNav(false));

    if (mobileNav) {
      mobileNav.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => toggleNav(false));
      });
    }

    if (cartOverlay) {
      cartOverlay.addEventListener('click', () => {
        toggleCart(false);
        toggleNav(false);
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (document.getElementById('cartDrawer')?.classList.contains('active')) toggleCart(false);
      if (document.getElementById('mobileNav')?.classList.contains('active')) toggleNav(false);
    });

    document.addEventListener('click', async (e) => {
      const openOnly = e.target.closest('.open-cart-trigger');
      if (openOnly) {
        e.preventDefault();
        if (openOnly.matches('button, .btn-primary, .btn-outline, .mobile-add-btn')) {
          showToast('Link this product in Theme Editor → Product gallery to enable checkout.');
        }
        toggleCart(true);
        return;
      }

      const cartActionButton = e.target.closest('[data-cart-action]');
      if (cartActionButton) {
        e.preventDefault();
        if (cartActionButton.disabled) return;

        const action = cartActionButton.dataset.cartAction;
        const lineKey = cartActionButton.dataset.lineKey;
        if (!action) return;

        const cartItem = cartActionButton.closest('.cart-item');
        const itemsContainer = cartActionButton.closest('[data-cart-items]');
        const line = itemsContainer && cartItem
          ? [...itemsContainer.querySelectorAll('.cart-item')].indexOf(cartItem) + 1
          : null;
        if (!lineKey && !(line > 0)) return;

        const qtyValueEl = cartItem?.querySelector('.cart-qty-value');
        const currentQty = Number(qtyValueEl?.textContent || 0);
        let nextQty = currentQty;

        if (action === 'increase') nextQty = currentQty + 1;
        if (action === 'decrease') nextQty = Math.max(0, currentQty - 1);
        if (action === 'remove') nextQty = 0;

        /* Optimistic UI — qty updates instantly; no not-allowed flash */
        applyOptimisticQty(cartItem, nextQty);
        setCartBusy(true);
        setCartStatus(action === 'remove' ? 'Removing item from cart.' : 'Updating cart quantity.');

        try {
          await updateCartLine({ lineKey, line, quantity: nextQty });
          setCartStatus(action === 'remove' ? 'Item removed from cart.' : 'Cart updated.');
        } catch (err) {
          setCartStatus('Could not update cart.');
          showToast(err.message, 'error');
          try { await fetchCart(); } catch (e) { /* keep error toast */ }
        } finally {
          setCartBusy(false);
        }
        return;
      }

      const btn = e.target.closest('button[data-variant-id]');
      if (!btn) return;
      e.preventDefault();

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const qtyScope = btn.closest('.product-page-form, form');
      const qtyInput = qtyScope ? qtyScope.querySelector('.product-quantity-input') : null;
      const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      setCartStatus('Adding item to cart.');

      try {
        await addToCart(variantId, quantity);
        setCartStatus('Item added to cart.');
        toggleCart(true);
      } catch (err) {
        setCartStatus('Could not add item to cart.');
        showToast(err.message, 'error');
      } finally {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    });

    document.querySelectorAll('.scroll-to-products, .scroll-to-fourher-product').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById('fourher-product') || document.getElementById('products');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.location.href = '/';
        }
      });
    });

    getCartSurfaces().checkoutBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        window.location.href = '/checkout';
      });
    });
  }

  function bindProductPage() {
    document.querySelectorAll('.product-quantity-control').forEach((control) => {
      const input = control.querySelector('.product-quantity-input');
      if (!input) return;

      control.querySelectorAll('[data-qty-action]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const current = Math.max(1, parseInt(input.value, 10) || 1);
          const next = btn.dataset.qtyAction === 'decrease' ? Math.max(1, current - 1) : current + 1;
          input.value = next;
        });
      });

      input.addEventListener('change', () => {
        const value = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = value;
      });
    });

    document.querySelectorAll('.product-page-media').forEach((media) => {
      const track = media.querySelector('.product-page-main-image');
      const thumbs = media.querySelector('.product-page-thumbs');
      if (!track) return;
      const slides = Array.from(track.querySelectorAll('.product-page-slide'));
      const thumbButtons = thumbs ? Array.from(thumbs.querySelectorAll('.product-page-thumb')) : [];
      if (slides.length < 2) return;

      const setActiveThumb = (index) => {
        thumbButtons.forEach((btn, i) => btn.classList.toggle('is-active', i === index));
      };

      thumbButtons.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const target = slides[index];
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          setActiveThumb(index);
        });
      });

      // Swiping the main image (touch, trackpad, or click-drag) scrolls the slide
      // strip natively; this keeps the thumbnail highlight in sync with whichever
      // slide is actually in view, however the user got there.
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            const index = slides.indexOf(entry.target);
            if (index !== -1) setActiveThumb(index);
          }
        });
      }, { root: track, threshold: 0.6 });

      slides.forEach((slide) => observer.observe(slide));
    });
  }

  function bindHeroVideo() {
    const video = document.getElementById('heroVideo')
      || document.getElementById('heroVideoDesktop')
      || document.getElementById('heroVideoMobile');
    if (!video) return;
    const cover = document.getElementById('heroVideoCover');

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause();
      video.style.display = 'none';
      return;
    }

    const mq = window.matchMedia('(max-width: 900px)');
    const hideCover = () => {
      if (cover && !video.paused && video.currentTime > 0.05) {
        cover.classList.add('is-hidden');
      }
    };
    const showCover = () => {
      if (cover) cover.classList.remove('is-hidden');
    };

    const applySrc = () => {
      const mobile = mq.matches;
      const next = mobile ? video.dataset.srcMobile : video.dataset.srcDesktop;
      const poster = mobile ? video.dataset.posterMobile : video.dataset.posterDesktop;
      if (poster) {
        video.poster = poster;
        if (cover) cover.src = poster;
      }
      if (!next) return;
      const current = video.currentSrc || video.src || '';
      const token = mobile ? 'hero-mobile' : 'hero-desktop';
      if (!current.includes(token)) {
        showCover();
        video.src = next;
        video.load();
      }
    };

    const prep = () => {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.controls = false;
      video.removeAttribute('controls');
      video.playsInline = true;
      video.loop = true;
      video.autoplay = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('loop', '');
      video.setAttribute('autoplay', '');
    };

    let restarting = false;
    const tryPlay = () => {
      if (document.visibilityState === 'hidden') return;
      prep();
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(() => {
          if (!video.paused) hideCover();
        }).catch(() => { showCover(); });
      }
    };

    const restart = () => {
      if (restarting) return;
      restarting = true;
      try { video.currentTime = 0; } catch (_) { /* ignore */ }
      const done = () => { restarting = false; };
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(() => { hideCover(); done(); }).catch(done);
      } else {
        done();
      }
    };

    prep();
    applySrc();
    showCover();

    video.addEventListener('playing', hideCover);
    video.addEventListener('timeupdate', hideCover);
    video.addEventListener('ended', restart);
    video.addEventListener('pause', () => {
      if (document.visibilityState !== 'visible') return;
      if (video.ended || (video.duration && video.currentTime >= video.duration - 0.4)) {
        restart();
      } else if (video.currentTime < 0.35) {
        showCover();
      }
    });
    video.addEventListener('loadeddata', tryPlay);
    video.addEventListener('canplay', tryPlay);

    tryPlay();

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', () => { applySrc(); tryPlay(); });
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(() => { applySrc(); tryPlay(); });
    }

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') tryPlay();
    });
    document.addEventListener('pointerdown', tryPlay, { passive: true });
    document.addEventListener('keydown', tryPlay);

    const hero = document.getElementById('hero');
    if (hero && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) tryPlay();
        });
      }, { threshold: 0.05 });
      io.observe(hero);
    }
  }

  function bindLazyVideos() {
    const videos = document.querySelectorAll('[data-lazy-video]');
    if (!videos.length) return;

    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Nothing is downloaded (preload="none", no src attribute) until a clip actually
    // scrolls into view, and playback pauses again the moment it scrolls back out —
    // an off-screen "In The Wild" video costs zero decode/network/battery this way.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (!video.src && video.dataset.src) {
            video.src = video.dataset.src;
          }
          if (!reducedMotion) {
            video.play().catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.25, rootMargin: '0px 0px 200px 0px' });

    videos.forEach((video) => observer.observe(video));
  }

  function bindScrollReveal() {
    if (!document.documentElement.classList.contains('js-reveal-ready')) return;

    const targets = document.querySelectorAll('[data-reveal]');
    if (!targets.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    targets.forEach((el) => observer.observe(el));
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindThemeToggle();
    bindSlider();
    bindStickyBar();
    bindProductCards();
    bindProductPage();
    bindScrollReveal();
    bindHeroVideo();
    bindLazyVideos();
    bindUI();
    bindNewsletterCopy();
    fetchCart();
  });
})();
